import '../../../assets/css/bills.css'
import React, { useEffect, useState } from 'react';

import '../../../components/purchase_service/applicant_requests/applicant_requests.css'
import { useLocation, useHistory } from 'react-router-dom';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import Pagination from "react-js-pagination";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import { get_off_catalogue_service_requests } from '../../../services/purchase_service';
import { download_orderRequest_quote, get_suppliers } from '../../../services/for_allServices';

import View_refuse_reason from './view_refuse_reason/view_refuse_reason';
const useStyles = makeStyles({
    input: {
        display: 'none',
    },
});


function Quotes_list() {
    const classes = useStyles();


    //savepoint

    let service = JSON.parse(localStorage.getItem('user-info'));

    const [requests, setRequests] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [open_reason_modal, setOpen_reason_modal] = useState(null);

    const location = useLocation();
    const history = useHistory();

    const query = new URLSearchParams(location.search);
    const currentPage = parseInt(query.get('page')) || 1;
    const filterType = query.get('filter') || 'all';
    const selectedSupplier = query.get('supplier') || '';
    const order = query.get('order') || null;


    const fetchData = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append('id_service', service.id);

        const searchValue = filterType === 'fournisseur' ? selectedSupplier : '';

        try {
            const res = await get_off_catalogue_service_requests(
                formData,
                filterType,
                searchValue,
                currentPage,
                order
                
            );
            setRequests(res.data.data);
            setTotalItems(res.data.total);
        } catch (err) {
            console.error("Error loading requests:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        get_suppliers().then(res => setSuppliers(res.data));
    }, [filterType, selectedSupplier, currentPage,order]);

    const updateUrl = (params) => {
        const updatedParams = new URLSearchParams(location.search);
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                updatedParams.set(key, value);
            } else {
                updatedParams.delete(key);
            }
        });
        history.push({ pathname: location.pathname, search: updatedParams.toString() });
    };

    const handleSupplierChange = (e) => {
        updateUrl({ supplier: e.target.value, filter: 'fournisseur', page: 1 });
    };

    const handleStatusChange = (e) => {
        updateUrl({ filter: e.target.value, supplier: '', page: 1 });
    };

    const change_page = (pageNumber) => {
        updateUrl({ page: pageNumber });
    };

    function download_quote(e, order_infos) {
        e.stopPropagation();
        let formData = new FormData();
        formData.append('request_code', order_infos.request_code);
        formData.append('order_id', order_infos.order_id);

        download_orderRequest_quote(formData).then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;

            let file_extension = 'pdf';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename')) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
                }
            }

            fileLink.setAttribute(
                'download',
                `${order_infos.request_code.replaceAll(" ", "_")}_${order_infos.order_id}_devis.${file_extension}`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
        }).catch(err => {
            console.error("Error downloading quote", err);
        });
    }


    return (
        <>
            <div className='applicant_request_view'>
                <div className='three_forms_header_container'>
                    <div className='page_title'>Devis</div>
                    <div className='search_filter_container'>
                    <FormControl variant="standard" className="header_form">
                        <InputLabel id="supplier-select-label">Fournisseurs disponible</InputLabel>
                        <Select
                            value={selectedSupplier}
                            onChange={handleSupplierChange}
                            labelId="supplier-select-label"
                        >
                            <MenuItem value="" disabled>Maison mère -- Fournisseur</MenuItem>
                            {suppliers.map((supplier, id) => (
                                <MenuItem value={supplier.id} key={id}>
                                    {supplier.parentCompany + " -- " + supplier.fullName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl variant='standard' className="header_form">
                        <InputLabel id="supplier-select-label">Ordre</InputLabel>
                        <Select
                            value={order || ''}
                            onChange={(e) => updateUrl({ order: e.target.value, page: 1 })}
                            name="order"
                        >
                            <MenuItem value="all">Tous</MenuItem>
                            <MenuItem value="asc">Récent</MenuItem>
                            <MenuItem value="desc">Ancien</MenuItem>
                        </Select>
                    </FormControl>
                    </div>
                </div>

                {/* Rest of your component remains the same */}
                <div className="bills_table_container">
                    <TableContainer className="bills_table">
                        <Table className='applicant_requests_table'>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ marginRight: '20px' }}>Code de demande</TableCell>
                                    <TableCell>Fournisseur</TableCell>
                                    <TableCell>Devis</TableCell>
                                    <TableCell>Date d'ajout</TableCell>
                                    <TableCell>Retenue</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {requests.length > 0 ? (
                                    requests.map((requestRow, id) => (
                                        <TableRow key={"offcat_" + id}>
                                            <TableCell>{requestRow.request_code}</TableCell>
                                            <TableCell>
                                            {
                                                (() => {
                                                    const match = suppliers.find(s => s.id === requestRow.id_supplier);
                                                    return match ? match.fullName : requestRow.id_supplier;
                                                })()
                                            } 
                                            </TableCell>
                                            <TableCell>
                                                {requestRow.quote ? (
                                                    <Tooltip title="Télécharger le devis" placement="bottom">
                                                        <span
                                                            style={{ marginRight: '8px' }}
                                                            onClick={(e) => download_quote(e, requestRow)}
                                                        >
                                                            <Fab
                                                                size="small"
                                                                style={{ backgroundColor: '#efefef', color: 'black' }}
                                                                className={requestRow.order_state !== null ? "round_button" : "round_button disabled_button"}
                                                            >
                                                                <DownloadIcon className="my_icon" />
                                                            </Fab>
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <span style={{ color: '#aaa' }}>Aucun devis déposé</span>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {requestRow.quoteStudy_date ? new Date(requestRow.quoteStudy_date).toLocaleDateString() : "Pas encore"}
                                            </TableCell>
                                            <TableCell>
                                                {
                                                    requestRow.service_accord === null
                                                        ? <Button variant="contained" className="status_waiting">Pas encore</Button>
                                                        : requestRow.service_accord === 1
                                                            ? <Button variant="contained" className="status_success">Oui</Button>
                                                            : <Button variant="contained" className="status_deny">Non</Button>
                                                }
                                                <>
                                                    {
                                                        requestRow.order_state === "non retenue"
                                                            ? <span className='view_reason_button' onClick={(e) => { e.stopPropagation(); setOpen_reason_modal(requestRow.service_refuse_reason) }}>Motif</span>
                                                            : <></>
                                                    }
                                                </>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            Aucune demande disponible
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                {totalItems > 0 && (
                    <div className="pagination_container">
                        <Pagination
                            activePage={currentPage}
                            itemsCountPerPage={6}
                            totalItemsCount={totalItems}
                            pageRangeDisplayed={4}
                            onChange={change_page}
                        />
                    </div>
                )}
            </div>

            {open_reason_modal !== null && (
                <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
            )}

            <Backdrop open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}
export default Quotes_list;